var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "li",
      {
        staticClass: "list-group-item activity-item py-2",
        class: { unread: !_vm.read, completed: _vm.complete },
      },
      [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "img col-auto" }, [
            _c(
              "div",
              { staticClass: "pretty p-jelly p-primary p-icon p-centered m-0" },
              [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.complete },
                  on: {
                    change: function ($event) {
                      return _vm.handleChange($event, _vm.id)
                    },
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-10 comment-section pl-0",
              on: {
                click: function ($event) {
                  return _vm.gotToAnchor(_vm.clientProfileId, _vm.boardId)
                },
              },
            },
            [
              _c(
                "h6",
                {
                  staticClass:
                    "text-primary bold activity-title text-truncate mb-0 clickable",
                  attrs: { title: _vm.strippedDescription },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.strippedDescription) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "mb-0 d-flex flex-row align-items-center" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "bold activity-subtitle mr-1",
                      class: _vm.getFormatClass(),
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatTimeAgo()) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "activity-creator activity-subtitle" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.fullName()) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "state p-success p-primary-alt" }, [
      _c("i", { staticClass: "icon fa fa-check" }),
      _vm._v(" "),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }